import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { t } from './common/LocalizationProvider';
import ConfirmHandler from "./shared/ConfirmHandler";

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import {makeStyles} from "@material-ui/core/styles";
import {cyberStyles} from "./cssShared/cyberTheme";

const useStyles = makeStyles(theme => ({
    ...cyberStyles(theme),
}));

const EditCollectionViewDevice = ({ editPath, endpoint, menuAnchor, setMenuAnchor}) => {
    const history = useHistory();
    const classes = useStyles();

    const [openDialog, setOpenDialog] = useState(false);

    const handleEdit = () => {
        history.push(`${editPath}/${menuAnchor?.id}`);
        setMenuAnchor(null);
    }
    const handleOpenDialog = () => {
        setOpenDialog(true);
        setMenuAnchor(prev => ({...prev, el:null}))
    }

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setMenuAnchor(null);
    }

    const handleCommand = () => {
        history.push(`command/${menuAnchor?.id}`);
        setMenuAnchor(null);
    }

    return (
        <>
            <Menu
                open={!!menuAnchor?.el}
                anchorEl={menuAnchor?.el}
                onClose={() => setMenuAnchor(null)}
                className={classes.menu}
            >
                <MenuItem className={classes.menuItem} onClick={handleEdit}>{t('sharedEdit')}</MenuItem>
                <MenuItem className={classes.menuItem} onClick={handleOpenDialog}>{t('sharedRemove')}</MenuItem>
                <MenuItem className={classes.menuItem} onClick={handleCommand}>{t('commands')}</MenuItem>
            </Menu>
            <ConfirmHandler open={openDialog} endpoint={endpoint} itemId={menuAnchor?.id} handleCloseDialog={handleCloseDialog}/>

        </>
    );
}

export default EditCollectionViewDevice;
